// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jq9f","name":"styles_name__1LSfa","phone":"styles_phone__acBW3"};